import { PARENT_CATEGORY } from "../../actions/type";
export default function categories(state = [], action) {
    switch (action.type) {
        case PARENT_CATEGORY:
            return action.payload;
        default:
            return state
    }
}